const API_URL = 'https://server.balloads.com/v1/admin';
// const API_URL = 'http://127.0.0.1:3009/v1/admin';

exports.SIGNIN_URL = `${API_URL}/core-sign-in`;
exports.UAC_URL = `${API_URL}/uac`;
exports.GET_COLLECTION_DATA = `${API_URL}/collection-data`;
exports.GET_COLLECTION_AGGREGATE_DATA = `${API_URL}/collection-aggregate-data`;
exports.USER_URL = `${API_URL}/user`;
exports.COUNTRIES_URL = `${API_URL}/get-countries`;
exports.COLLECTORS_URL = `${API_URL}/get-collectors`;
exports.COUNTRYS_URL =  `${API_URL}/get-countries`;
exports.SEARCH_COLLECTION_URL = `${API_URL}/search-collection`;
exports.GET_WASTE_REPORT_URL = `${API_URL}/waste-report`;
exports.GET_FINANCE_REPORT_URL = `${API_URL}/finance-report`;
exports.GET_TERRITORIES = `${API_URL}/territories`;
exports.PRODUCT_URL = `${API_URL}/product`;
exports.MEDIA_URL = `${API_URL}/media`;
exports.GET_PRE_SIGNED_URL = `${API_URL}/generate-pre-signed-url`;
exports.GET_COLLECTION_WASTE_REPORT_URL = `${API_URL}/collection-wastes-report`;
exports.GET_USER_REPORT_URL = `${API_URL}/user-report`;
exports.SUBURB_URL = `${API_URL}/suburb`;
exports.STATE_URL = `${API_URL}/state`;
exports.COUNTRY_URL = `${API_URL}/country`;
exports.COLLECTOR_URL = `${API_URL}/collector`;
exports.GET_ZONE_URL = `${API_URL}/zone`;
exports.TERRITORY_URL = `${API_URL}/territory`;
exports.ZONE_URL = `${API_URL}/zone`;
exports.NOTIFICATION_URL = `${API_URL}/notification`;
exports.WASTE_URL = `${API_URL}/waste`;
exports.CITY_URL = `${API_URL}/city`;
exports.FETCH_URL = `${API_URL}/image/`;
exports.GET_COLLECTOR_URL = (id) => `${API_URL}/collector/${id}`;
exports.GET_USER_URL = (id) => `${API_URL}/user/${id}`;
exports.TRANSACTION_URL = `${API_URL}/transaction`;
exports.SOCKET_URL = 'http://127.0.0.1:3002';
